import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Progress} from 'antd';
import {
  StyledCreditCardSummary,
  StyledCreditCardSummaryContainer,
  StyledCreditCardSummaryLimit,
  StyledCreditCardSummaryLimitHelper,
} from './StyledCreditCardSummary';
import {cardsHelpers} from '../../utils/helpers';
import {cardTypesConstants} from '../../constants';

const CreditCardSummary = ({
  enableLimit = true,
  limits,
  name,
  variant = cardTypesConstants.SUBSCRIPTION,
  ...rest
}) => {

  const {percent, total, used} = useMemo(() => cardsHelpers.getCardLimitDetails(limits), [limits]);

  return (
    <StyledCreditCardSummaryContainer {...rest}>
      <StyledCreditCardSummary variant={variant}>
        {name}
      </StyledCreditCardSummary>

      {enableLimit && (
        <StyledCreditCardSummaryLimit>
          <Progress
            percent={percent}
            size='small'
            showInfo={false}
            status={percent > 100 ? 'exception' : 'success'}
          />
          <StyledCreditCardSummaryLimitHelper>
            <span>{used}</span>
            <span>{total}</span>
          </StyledCreditCardSummaryLimitHelper>
        </StyledCreditCardSummaryLimit>
      )}

    </StyledCreditCardSummaryContainer>
  )
}

CreditCardSummary.propTypes = {
  enableLimit: PropTypes.bool,
  limits: PropTypes.shape({
    limit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    used: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  name: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.values(cardTypesConstants))
}

export default CreditCardSummary;
